import { render, staticRenderFns } from "./BrandDetail.vue?vue&type=template&id=12c54045&scoped=true&"
import script from "./BrandDetail.vue?vue&type=script&lang=js&"
export * from "./BrandDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c54045",
  null
  
)

export default component.exports